module.exports = __webpack_public_path__ + "img/Willing Risk Taker.aca3bd21.svg";